module.exports = __webpack_public_path__ + "img/ic_32_exercises_oberkoerper.6e904587.svg";